import { pipe } from 'fp-ts/lib/function';
import { array, failure, parse, string, struct, success } from 'io-ts/Decoder';

export const Request = struct({
	itemIds: pipe(
		array(string),
		parse((v) => {
			if (!v.length) {
				return failure(v, 'at least one itemId is needed');
			}

			return success(v);
		})
	),
});
